import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './admin-benefit-templates.loaders';
import { benefitTemplatesKeys } from './admin-benefit-templates.queries';

export const useAdminCreateBenefitTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createBenefitTemplate, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitTemplatesKeys.all);
    },
  });
};

export const useAdminUpdateBenefitTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateBenefitTemplate, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitTemplatesKeys.all);
    },
  });
};

export const useAdminCopyBenefitTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.copyBenefitTemplate, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitTemplatesKeys.lists);
    },
  });
};

export const useAdminDeleteBenefitTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteBenefitTemplate, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitTemplatesKeys.lists);
    },
  });
};
